export default __webpack_public_path__ + "static/monogatari-cd55e60549240d8763251cff46833849.png";